import { render, staticRenderFns } from "./data-inspection-info.vue?vue&type=template&id=49d5d39e&scoped=true&"
import script from "./data-inspection-info.vue?vue&type=script&lang=js&"
export * from "./data-inspection-info.vue?vue&type=script&lang=js&"
import style0 from "./data-inspection-info.vue?vue&type=style&index=0&id=49d5d39e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5d39e",
  null
  
)

export default component.exports